import { Currency, HostAgencyType } from "@daytrip/legacy-enums";
import { Expose, Transform } from "class-transformer";
import {
    IsBoolean,
    IsDefined,
    IsEnum,
    IsInt,
    IsNumber,
    IsOptional,
    IsString,
    Matches,
    Max,
    Min,
} from "class-validator";

import { GField, GObjectType } from "../graphql";
import { CDBaseEntity, CDColumn, CDEntity, CDObjectIdColumn } from "../orm";

@GObjectType("HostAgency")
@CDEntity("hostAgencies")
export class HostAgency extends CDBaseEntity {
    @IsDefined()
    @Expose()
    @GField()
    @CDObjectIdColumn()
    @IsString()
    @Transform((value) => {
        return typeof value === "string" ? value.trim() : value;
    })
    public _id: string;

    @IsDefined()
    @Expose()
    @GField()
    @CDColumn()
    @IsString()
    public name: string;

    @IsDefined()
    @Expose()
    @GField()
    @CDColumn()
    @IsNumber()
    public currency: Currency = Currency.Dollar;

    @IsDefined()
    @Expose()
    @GField()
    @CDColumn()
    @IsString()
    @Matches(/^[a-z0-9\-_]+$/, {
        message: "url should contain only lowercase alphanumeric characters",
    })
    public url: string;

    @IsDefined()
    @Expose()
    @GField()
    @CDColumn()
    @IsNumber()
    @Min(0)
    @Max(1)
    public discountCoefficient: number;

    @IsDefined()
    @Expose()
    @GField()
    @CDColumn()
    @IsInt()
    @Min(0)
    @Max(100)
    public commissionPercentage: number;

    @IsDefined()
    @Expose()
    @GField()
    @CDColumn()
    @IsBoolean()
    public partnerBookingAvailable: boolean = false;

    @IsDefined()
    @Expose()
    @GField()
    @CDColumn()
    @IsString()
    public defaultCountryIso: string;

    @IsOptional()
    @Expose()
    @GField({ nullable: true })
    @CDColumn()
    @IsString()
    public ownerId?: string;

    @IsOptional()
    @Expose()
    @GField({ nullable: true })
    @CDColumn()
    @IsString()
    public logoUrl?: string;

    @IsOptional()
    @Expose()
    @GField(() => String, { nullable: true })
    @CDColumn()
    @IsEnum(HostAgencyType)
    @IsString()
    public type?: HostAgencyType;

    @IsDefined()
    @Expose()
    @GField()
    @CDColumn()
    @IsBoolean()
    public isCommissionHidden: boolean = false;
}
